import ScheduleEvent from './ScheduleEvent.vue';
import RescheduleEvent from './RescheduleEvent.vue';
import ViewEvent from './ViewEvent.vue';

export default {
    ScheduleEvent,
    RescheduleEvent,
    ViewEvent
}